import { ProductType } from '@plvs/client-data/models'
import {
  isCoachForScholasticRelatedTeam,
  isCaptainForResource,
  isTeamOwnerForResource,
} from '@plvs/utils'
import { CompetitionGroup, PhaseType } from '@plvs/graphql/generated'
import {
  QueueComponentProps,
  QueueComponentReturn,
} from '../types/queueController.types'

export const determineQueueRender = ({
  productType,
  userRoles,
  team,
  phaseType,
  teamCompetitionGroup,
}: QueueComponentProps): QueueComponentReturn => {
  const hideFAQs = phaseType === PhaseType.Qualifier
  // In College, players who create teams are assigned the Team Owner role,
  // but are displayed in the UI as Team Captain.
  // Since they don't receive an explicit captain role, we check for the Team Owner role
  // when the competition group is College.
  const collegeTeamOwnerCanEnqueue =
    teamCompetitionGroup === CompetitionGroup.College &&
    isTeamOwnerForResource(userRoles, [team.id])
  return {
    canEnqueue:
      productType === ProductType.Scholastic
        ? isCoachForScholasticRelatedTeam(userRoles, team) ||
          isCaptainForResource(userRoles, [team.id]) ||
          collegeTeamOwnerCanEnqueue
        : isTeamOwnerForResource(userRoles, [team.id]),
    showFAQs: hideFAQs ? false : productType === ProductType.Scholastic,
  }
}
